export default __webpack_public_path__ + "static/media/hero-bg.2406a5c1.png";